import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHookSection } from './components/OpeningHookSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { CredibilitySection } from './components/CredibilitySection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <main className="min-h-screen bg-navy-900 font-sans selection:bg-gold selection:text-navy-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHookSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedAttemptsSection data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <CredibilitySection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <FooterSection data-id="element-12" />
    </main>;
}